import Completed from './Completed'

export default Completed

export type {CompletedProps} from './Completed'
